import React from 'react';

import autoBind from 'react-autobind';
import { If, Then } from 'react-if'

// import other components within the same project here

import Localization from "composer/Localization.jsx"
import Config from "composer/Config.jsx";

import { Button, Icon, TextField, InputAdornment, Tooltip } from '@material-ui/core';
import { Stage, Layer, Rect, Text, Line } from 'react-konva';
import {
  blueGrey,
  blue,
  grey,
} from '@material-ui/core/colors'

class ContentMindMap extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      stageOffsetHeight: 0,
      stageWidth: 375,
      stageHeight: 300,
      boxWidth: 100,
      boxHeight: 40,
      boxPadding: 4,
      linkList: [],
      boxList: [],
      boxDict: {},
      currentBoxID: -1,
      currentLinkID: -1,
      textFieldVisible: false,
      textFieldX: 0,
      textFieldY: 0,
      textFieldValue: "",
      addingLink: false,
    };
    autoBind(this);

    let payload = this.props.parent.state.contentPayload;
    if (payload != null) {
      this.state.linkList = (payload.linkList != null? payload.linkList : []);
      this.state.boxList = (payload.boxList != null? payload.boxList : []);
    }

    this.updateMindMapBoxDict();
  }

  componentDidMount() {
    let stageDiv = this.refs.stageDiv.getBoundingClientRect();
    let offset = stageDiv.y;
    this.setState({ stageOffsetHeight: offset });
    this.state.stageOffsetHeight = offset;
  }

  updateMindMapBoxDict() {
    this.state.boxDict = {};
    for (let i = 0; i < this.state.boxList.length; i++) {
      let key = this.state.boxList[i].id;
      if (this.state.boxDict[key] == null) {
        this.state.boxDict[key] = this.state.boxList[i];
      }
    }
  }

  handleDragStart(e) {
    let attrs = e.target.attrs;
    let id = attrs.id;
    this.setState({ currentBoxID: id });
    this.state.currentBoxID = id;
  }

  handleDragMove(e) {
    let attrs = e.target.attrs;
    let id = attrs.id;
    let x = attrs.x;
    let y = attrs.y;
    if (attrs.name == "text") {
        x -= this.state.boxPadding / 2.0;
        y -= this.state.boxPadding / 2.0;
    }
    x = Math.max(x, 0);
    y = Math.max(y, 0);
    let boxList = this.state.boxList.slice();
    for (let i = 0; i < boxList.length; i++) {
      if (boxList[i].id == id) {
        boxList[i].x = x;
        boxList[i].y = y;
      }
    }
    this.setState({ boxList: boxList });
    this.state.boxList = boxList;
    this.updatePayload();
  }

  handleDragEnd(e) {
    
  }

  handleTextClick(e) {
    let rect = e.target.getClientRect();
    let absPos = e.target.getAbsolutePosition();
    let text = e.target.attrs.text;
    let id = e.target.attrs.id;
    let y = absPos.y + rect.height;
    this.setState({
      textFieldVisible: true,
      textFieldX: absPos.x,
      textFieldY: y,
      textFieldValue: text,
      currentBoxID: id,
    });
    this.state.textFieldVisible = true;
    this.state.textFieldX = absPos.x;
    this.state.textFieldY = y;
    this.state.textFieldValue = text;
    this.state.currentBoxID = id;
  }

  handleTextFieldChanged(e) {
    let boxList = this.state.boxList.slice();
    for (let i = 0; i < boxList.length; i++) {
      if (boxList[i].id == this.state.currentBoxID) {
        boxList[i].label = e.target.value;
      }
    }
    this.setState({
      textFieldValue: e.target.value,
      boxList: boxList,
    });
    this.state.textFieldValue = e.target.value;
    this.state.boxList = boxList;
    this.updatePayload();
  }

  mindMapBoxClicked(e) {
    let attrs = e.target.attrs;
    let id = attrs.id;
    if (this.state.addingLink) {
      this.addMindMapLink(id);
    }
    else {
      this.setState({ currentBoxID: id });
      this.state.currentBoxID = id;
    }

    this.setState({ currentLinkID: -1 });
    this.state.currentLinkID = -1;
  }

  mindMapLinkClicked(e) {
    let attrs = e.target.attrs;
    let id = attrs.id;
    this.setState({
      currentBoxID: -1,
      currentLinkID: id,
    });
    this.state.currentBoxID = -1;
    this.state.currentLinkID = id;
  }

  mindMapLink(link) {
    let points = [];
    let point0 = this.state.boxDict[link[0]];
    let point1 = this.state.boxDict[link[1]];
    if (point0 != null) {
      points.push(point0.x + this.state.boxWidth / 2);
      points.push(point0.y + this.state.boxHeight / 2);
    }
    if (point1 != null) {
      points.push(point1.x + this.state.boxWidth / 2);
      points.push(point1.y + this.state.boxHeight / 2);
    }
    let id = points.toString();
    return (
      <Line
        id={id}
        points={points}
        stroke={id == this.state.currentLinkID? blueGrey[300] : blueGrey[500]}
        strokeWidth={2}
        onClick={this.mindMapLinkClicked}
      />
    )
  }

  mindMapBox(box) {
    let kind = (box.kind != null? box.kind : 0);
    let x = (box.x != null? box.x : 0);
    let y = (box.y != null? box.y : 0);
    let color = blue[500];
    if (box.id == this.state.currentBoxID) {
      color = blue[300];
    }
    return [
      <Rect
        id={box.id}
        x={x}
        y={y}
        width={this.state.boxWidth}
        height={this.state.boxHeight}
        fill={color}
        cornerRadius={4}
        shadowBlur={4}
        shadowOffsetX={2}
        shadowOffsetY={2}
        shadowOpacity={0.4}
        draggable={true}
        onClick={this.mindMapBoxClicked}
        onDragStart={this.handleDragStart}
        onDragMove={this.handleDragMove}
        onDragEnd={this.handleDragEnd}
      />,
      <If condition={kind==0}>
        <Then>
          <Rect
            x={x + this.state.boxPadding / 2.0}
            y={y + this.state.boxPadding / 2.0}
            fill={'White'}
            width={this.state.boxWidth - this.state.boxPadding}
            height={this.state.boxHeight - this.state.boxPadding}
            cornerRadius={2}
          />
        </Then>
      </If>,
      <Text
        id={box.id}
        name='text'
        x={x + this.state.boxPadding / 2.0}
        y={y + this.state.boxPadding / 2.0}
        text={(kind == 0? box.label : Localization.strings.MIND_MAP_FILL_IN_BOX)}
        fill={kind == 0? 'Black' : 'White'}
        fontSize={12}
        align='center'
        verticalAlign='middle'
        wrap='word'
        width={this.state.boxWidth - this.state.boxPadding}
        height={this.state.boxHeight - this.state.boxPadding}
        draggable={true}
        onDragStart={this.handleDragStart}
        onDragMove={this.handleDragMove}
        onDragEnd={this.handleDragEnd}
        onClick={(kind == 0 && !this.state.addingLink? this.handleTextClick : this.mindMapBoxClicked)}
        onDblClick={(kind == 0 && !this.state.addingLink? this.handleTextClick : this.mindMapBoxClicked)}
      />
    ]
  }

  getMaxBoxID() {
    let id = 0;
    for (let i = 0; i < this.state.boxList.length; i++) {
      if (this.state.boxList[i].id >= id) {
        id = this.state.boxList[i].id + 1;
      }
    }
    return id;
  }

  addMindMapLabel() {
    let boxList = this.state.boxList.slice();
    let box = {
      id: this.getMaxBoxID(),
      kind: 0,
      label: Localization.strings.MIND_MAP_LABLE_BOX,
      x: 0,
      y: 0,
    }
    boxList.push(box);
    this.setState({ boxList: boxList });
    this.state.boxList = boxList;

    this.updateMindMapBoxDict();
    this.updatePayload();
  }

  finishEditMindMapLabel() {
    this.setState({ textFieldVisible: false });
    this.state.textFieldVisible = false;
  }

  addMindMapFillIn() {
    let boxList = this.state.boxList.slice();
    let box = {
      id: this.getMaxBoxID(),
      kind: 1,
      x: 0,
      y: 0,
    }
    boxList.push(box);
    this.setState({ boxList: boxList });
    this.state.boxList = boxList;

    this.updateMindMapBoxDict();
    this.updatePayload();
  }

  deleteMindMapBox() {
    let dialogText = {
      title: Localization.strings.DELETE_MIND_MAP_BOX,
      content: Localization.strings.DELETE_REMINDER,
      confirm: Localization.strings.DELETE,
    }
    this.props.root.refs.confirmDialog.show(dialogText, this.deleteMindMapBoxConfirmClicked, this.deleteMindMapBoxCancelClicked);
  }

  deleteMindMapBoxConfirmClicked() {
    if (this.state.currentBoxID >= 0) {
      let boxList = this.state.boxList.slice();
      let removeIndex = -1;
      for (let i = 0; i < boxList.length; i++) {
        if (boxList[i].id == this.state.currentBoxID) {
          removeIndex = i;
        }
      }
      if (removeIndex >= 0) {
        boxList.splice(removeIndex, 1);
      }

      let linkList = [];
      for (let i = 0; i < this.state.linkList.length; i++) {
        let link = this.state.linkList[i];
        if (link[0] == this.state.currentBoxID || link[1] == this.state.currentBoxID) {

        }
        else {
          linkList.push(link);
        }
      }
      this.setState({
        boxList: boxList,
        linkList: linkList,
      });
      this.state.boxList = boxList;
      this.state.linkList = linkList;
      this.updatePayload();
    }
  }

  deleteMindMapBoxCancelClicked() {

  }

  linkMindMapBox() {
    this.setState({ addingLink: true });
    this.state.addingLink = true;
  }

  addMindMapLink(id) {
    let linkList = this.state.linkList;
    let link = [this.state.currentBoxID, id];
    let duplicatedLink = false;
    for (let i = 0; i < linkList.length; i++) {
      if (link[0] == linkList[i][0] && link[1] == linkList[i][1]) {
        duplicatedLink = true;
      }
    }
    if (!duplicatedLink) {
      linkList.push(link);
      this.setState({
        addingLink: false,
        linkList: linkList,
      });
      this.state.addingLink = false;
      this.state.linkList = linkList;
      this.updatePayload();
    }
  }

  deleteMindMapLink() {
    let dialogText = {
      title: Localization.strings.DELETE_MIND_MAP_LINK,
      content: Localization.strings.DELETE_REMINDER,
      confirm: Localization.strings.DELETE,
    }
    this.props.root.refs.confirmDialog.show(dialogText, this.deleteMindMapLinkConfirmClicked, this.deleteMindMapLinkCancelClicked);
  }

  deleteMindMapLinkConfirmClicked() {
    if (this.state.currentBoxID >= 0) {
      let linkList = [];
      for (let i = 0; i < this.state.linkList.length; i++) {
        let link = this.state.linkList[i];
        if (link[0] == this.state.currentBoxID || link[1] == this.state.currentBoxID) {

        }
        else {
          linkList.push(link);
        }
      }
      this.setState({
        linkList: linkList,
      });
      this.state.linkList = linkList;
      this.updatePayload();
    }
  }

  deleteMindMapLinkCancelClicked() {

  }

  clearSelection() {
    this.setState({
      currentBoxID: -1,
      currentLinkID: -1,
      addingLink: false,
    });
    this.state.currentBoxID = -1;
    this.state.currentLinkID = -1;
    this.state.addingLink = false;

    this.finishEditMindMapLabel();
  }

  updatePayload() {
    let payload = {
      linkList: this.state.linkList,
      boxList: this.state.boxList,
    }
    this.props.parent.setPayload(payload);
  }

  render() {
    return (
      <div>
        <Tooltip title={Localization.strings.ADD_MIND_MAP_LABLE_BOX}>
          <Button
            color="primary"
            onClick={this.addMindMapLabel}
          >
            <Icon className="buttonIconLeft">add</Icon>
            {Localization.strings.MIND_MAP_LABLE_BOX}
          </Button>
        </Tooltip>
        <Tooltip title={Localization.strings.MIND_MAP_FILL_IN_BOX}>
          <Button
            color="primary"
            onClick={this.addMindMapFillIn}
          >
            <Icon className="buttonIconLeft">add</Icon>
            {Localization.strings.MIND_MAP_FILL_IN_BOX}
          </Button>
        </Tooltip>
        <If condition={this.state.currentBoxID != -1}>
          <Then>
            <Tooltip title={Localization.strings.DELETE_MIND_MAP_BOX}>
              <Button
                onClick={this.deleteMindMapBox}
              >
                <Icon className="buttonIconLeft">clear</Icon>
                {Localization.strings.DELETE_MIND_MAP_BOX}
              </Button>
            </Tooltip>
            <Button
              onClick={this.linkMindMapBox}
            >
              <Icon className="buttonIconLeft">link</Icon>
              {Localization.strings.LINK_OTHER_MIND_MAP_BOX}
            </Button>
            <Button
              onClick={this.deleteMindMapLink}
            >
              <Icon className="buttonIconLeft">link_off</Icon>
              {Localization.strings.DELETE_MIND_MAP_LINK}
            </Button>
          </Then>
        </If>
        <div ref="stageDiv">
          <Stage width={this.state.stageWidth} height={this.state.stageHeight}>
            <Layer>
              <Rect
                x={0}
                y={0}
                width={this.state.stageWidth}
                height={this.state.stageHeight}
                fill={grey[200]}
                cornerRadius={4}
                onClick={this.clearSelection}
              />
            </Layer>
            <Layer>
              {
                this.state.linkList.map( (link, i) => {
                  return (
                    this.mindMapLink(link)
                  )
                })
              }
            </Layer>
            <Layer>
              {
                this.state.boxList.map( (box, i) => {
                  return (
                    this.mindMapBox(box)
                  )
                })
              }
            </Layer>
          </Stage>
        </div>
        <TextField
          ref="textInput"
          style={{
            display: this.state.textFieldVisible? 'block' : 'none',
            position: 'absolute',
            left: this.state.textFieldX + 'px',
            bottom: this.state.stageOffsetHeight - this.state.textFieldY + 'px',
            borderRadius: 4,
            backgroundColor: 'White',
            border: '2px solid ' + blue[500],
            padding: '4px'
          }}
          value={this.state.textFieldValue}
          onChange={this.handleTextFieldChanged}
          multiline
          InputProps={{
            endAdornment:
              <InputAdornment
                onClick={this.finishEditMindMapLabel}
                position="end"
                style={{cursor: "pointer"}}
              >
                <Icon>done</Icon>
              </InputAdornment>
          }}
          inputProps={{ maxLength: Config.MAX_TEXT_LEN().NAME }}
        />
      </div>
    )
  }
}

export default ContentMindMap;
